import { ChangeDetectionStrategy, Component } from '@angular/core';
import { socialsUriSmooved } from '@smooved/core';
import { Brand, SvgIllustration, UiContext, UiIconSize } from '@smooved/ui';

@Component({
    selector: 'app-general-info-footer',
    templateUrl: 'general-info-footer.component.html',
    styleUrls: ['general-info-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeneralInfoFooterComponent {
    public readonly brands = Brand;
    public readonly uiIconSize = UiIconSize;
    public readonly uiContext = UiContext;
    public readonly socialsUriSmooved = socialsUriSmooved;
    public readonly svgIllustration = SvgIllustration;
}
